<template>
  <div>
    <div>
      <div class="d-flex" style="margin-bottom: 1.70rem;">
        <router-link :to="`/${this.currentProduct.toLowerCase()}/legal-document-template`">
          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="38" viewBox="0 0 40 38" fill="none" style="cursor: pointer;">
            <path
              d="M38.75 19.0003H1.25M1.25 19.0003L18.9583 1.29199M1.25 19.0003L18.9583 36.7087"
              stroke="#FF7C48"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </router-link>
        <div class="d-flex align-items-center" style="margin-left: 1.25rem; gap: 2.34rem;">
          <div>
            <h1 class="title">{{ $t("legal-document-template.plural") }}</h1>
          </div>
        </div>
      </div>

      <h2 v-if="!isLoading && editedEntity" class="mb-1">
        <span v-if="isEditMode">"{{ editedEntity.name | translate }}" {{ $t("common.update") }}</span>
      </h2>

      <b-row>
        <b-col md="6">
          <sweet-input
            class="mt-3"
            v-model="form.name"
            :isValid="!$v.form.name.$error"
            @input="$v.form.name.$touch()"
            layout="vertical"
            :placeholder="$t('legal-document-review.name')"
            :label="$t('legal-document-review.name')"
          />
        </b-col>
      </b-row>

      <sweet-button @click="save()" type="submit" :loading="isUpdating" :disabled="isUpdating || $v.$invalid" variant="success" icon="mdi mdi-check" buttonClass="mt-2">
        {{ $t("common.save") }}
      </sweet-button>

      <hr />

      <h3 class="text-center m-5">{{ $t("legal-document-review.text") }}</h3>
      <Editor ref="editor" :hideMagic="true" />
    </div>
  </div>
</template>

<script>
import Editor from "@c/document-editor/document-editor";
import SweetTextarea from "@c/form/sweet-textarea";
import { maxLength, minLength, required } from "vuelidate/lib/validators";

export default {
  components: { Editor, SweetTextarea },
  data() {
    return {
      form: {
        content: [],
      },
    };
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(1),
        maxLength: maxLength(350),
      },
    },
  },
  computed: {
    criteria() {
      return this.$store.getters["inventoryFilter/criteria"];
    },
    editedEntity() {
      return this.$store.getters[`organizationLegalDocument/editedEntity`];
    },

    isLoading() {
      return this.$store.getters[`organizationLegalDocument/isLoading`];
    },
    isUpdating() {
      return this.$store.getters[`organizationLegalDocument/isUpdating`];
    },
    isEditMode() {
      return true;
    },
  },
  watch: {},
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      try {
        const id = this.$route.params.id;
        if (id) {
          const { data } = await this.$store.dispatch(`organizationLegalDocument/findById`, id);
          if (data.approved) {
            throw new Error("Already Approved");
          }
          this.$store.commit(`organizationLegalDocument/editedEntity`, data);

          this.form = {
            ...data,
            name: data.name[this.currentLanguage],
          };
          this.$refs.editor.content = data.content;
        }
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error, { customMessage: this.$t("common.sorry-page-not-found") });

        setTimeout(() => {
          this.$router.push(`/${this.currentProduct.toLowerCase()}/legal-document-template`);
        }, 1000);
      }
    },
    async save() {
      const ok = await this.confirm(this.$t(`alert.approve`));
      if (!ok) {
        return;
      }
      try {
        const form = {
          ...this.form,
          content: this.$refs.editor.getEditorContent(),
          criteria: this.criteria,
        };
        await this.$store.dispatch(`organizationLegalDocument/save`, form);
        this.$toast.success(this.$t("common.success"));

        setTimeout(() => {
          this.$router.push(`/${this.currentProduct.toLowerCase()}/legal-document-template`);
        }, 1000);
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
  },
};
</script>
